import cx from 'classnames'
import React from 'react'
import * as styles from '../styles/components/video.module.scss'
import reactElementToString from '../utils/react-element-to-string'

export interface VideoProps {
    title?: string
    vimeoId?: string
    embedCode?: string
    className?: string
    altText?: string
}

// https://help.vimeo.com/hc/en-us/articles/12426260232977-Player-parameters-overview
const vimeoUrlParams = new URLSearchParams({
    badge: '0',
    byline: '0',
    title: '0',
    autopause: '0',
    dnt: '1',
    quality_selector: '1',
    player_id: '0',
    actions: '0',
})

const Video = (props: VideoProps) => {
    const { title, embedCode, vimeoId, className, altText } = props
    let ariaLabel: string
    if (altText) {
        ariaLabel = altText
    } else if (title) {
        ariaLabel = `A video with the title '${title}'`
    } else {
        ariaLabel = 'A video'
    }

    return (
        <>
            {vimeoId && !embedCode &&
                <div className={cx(styles.videoWrapper, className )}>
                    <iframe
                        className={styles.video}
                        title={title}
                        src={`https://player.vimeo.com/video/${vimeoId}?${vimeoUrlParams.toString()}`}
                        allow="autoplay; fullscreen; picture-in-picture"
                        aria-label={ariaLabel}
                    />
                </div>
            }
            {embedCode && !vimeoId &&
                <div
                    className={cx(styles.videoWrapper, className)}
                    dangerouslySetInnerHTML={{ __html: reactElementToString(embedCode) }}
                />
            }
        </>
    )
}

export default Video
